/*---------------------------------------------------------------------------------------------
 *  Copyright (c) 2023 Vienna Hypertext Inc. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React, { Dispatch, SetStateAction, useState } from "react";

import { AboutScreen } from "src/components/Invites/AboutScreen";
import { TokenScreen } from "src/components/Invites/TokenScreen";
import { Modal } from "src/components/UI/Modal/Modal";

interface Props {
  setInviteActive: Dispatch<SetStateAction<boolean>>;
}
export function InviteFriends({ setInviteActive }: Props) {
  const [inviteScreen, setInviteScreen] = useState<"about" | "token">("about");
  const [inviteCode, setInviteCode] = useState<{ mnemonic: string; expiration: Date } | null>(null);

  const handleClose = () => {
    setInviteActive(false);
  };

  return (
    <Modal close={handleClose} title="Invite">
      {inviteScreen === "about" ? (
        <AboutScreen setInviteCode={setInviteCode} setInviteScreen={setInviteScreen} />
      ) : (
        inviteCode && <TokenScreen inviteCode={inviteCode} handleClose={handleClose} />
      )}
    </Modal>
  );
}
